import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const updateVendorProfile = (id, params) => {
  return Api(
    `${endPoints.updateVendorProfile}/${id}`,
    params,
    requestType.POST
  );
};
